module.exports = __webpack_public_path__ + "img/dxctj-2000.9996f47b.jpg";